import { render, staticRenderFns } from "./orderDIFOTSummaryWidget.vue?vue&type=template&id=672f84f7&"
import script from "./orderDIFOTSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./orderDIFOTSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports